<template>
    <modal
            name="broshure"
            @before-open="beforeOpen" class="text-black-50"
            :adaptive="true"
            height="auto"
    >
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-title">
                    <div class="row">
                        <div class="col-2">
                            <img src="@/assets/images/compax.png" class="modal-icon" height="50">
                        </div>
                        <div class="col-10">
                            <h2 style="font-weight: bold;" class="py-1 px-1 ml-3 modal-title">{{this.title}}</h2>
                        </div>

                    </div>
                </div>
            </div>
            <div class="modal-body">
                <form>
                    <div class="row px-3">
                        <p>Compila i seguenti campi. Riceverai subito via e-email la brochure dedicata ai nostri servizi
                            per l'architettura dove troverai tutti i dettagli di cui hai bisogno</p>
                        <input type="text" v-model="form.email" class="form-control" id="inputEmail" placeholder="Email:"
                               style="border-radius: 20px; background-color: #c7c7c7;">
                    </div>
                    <div class="row py-4 px-3">
                        <input type="checkbox" class="form-check-input ml-0" id="exampleCheck1" v-model="policy">
                        <label class="form-check-label ml-4" for="exampleCheck1">Dichiaro di aver
                            accettato
                            la
                            privacy policy.</label>

                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn button-gray ml-auto" v-on:click="sendMessage">Invia</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import axios from "axios";

    export default {
        name: "BroshureModal",
        data() {
            return {
                title: '',
                form: {
                    email: '',
                    identifier: ''
                },
                policy: false
            }
        },
        methods: {
            beforeOpen(event) {
                this.title = event.params.title
                this.form.identifier = event.params.identifier
            },
            sendMessage() {
                axios.post('http://www.mc2comunicazione.com/mailserver/broshure', this.form)
            }
        }
    }
</script>

<style scoped>

</style>